module.exports = __webpack_public_path__ + "img/Sethiwan Group mobile.161d1207.png";